/** @jsxImportSource @emotion/react */
import React, { MouseEvent, PropsWithChildren } from "react";
import { SerializedStyles } from "@emotion/react";

import { styButton } from "./styles";

interface ButtonProps {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  customStyles?: SerializedStyles;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const Button = ({
  onClick = () => undefined,
  children,
  customStyles,
  disabled,
  type,
}: PropsWithChildren<ButtonProps>) => {
  return (
    <button
      css={[styButton, customStyles]}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;
